import React from 'react';

export const AdmissionProcess = () => {
  return (
    <section id="admission" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <span className="bg-blue-100 text-blue-600 px-4 py-2 rounded-full text-sm font-semibold">Getting Started</span>
          <h2 className="text-5xl font-bold text-gray-900 mt-4 mb-4">Admission Process</h2>
          <p className="text-xl text-gray-600">Simple 4-step process to begin your OSSD journey</p>
        </div>

        {/* Steps */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mb-16">
          <div className="text-center">
            <div className="bg-blue-600 text-white w-20 h-20 rounded-full flex items-center justify-center text-3xl font-bold mx-auto mb-4">1</div>
            <h3 className="text-xl font-bold mb-3">Initial Consultation</h3>
            <p className="text-gray-600">Free consultation to discuss your goals and eligibility</p>
          </div>
          <div className="text-center">
            <div className="bg-blue-600 text-white w-20 h-20 rounded-full flex items-center justify-center text-3xl font-bold mx-auto mb-4">2</div>
            <h3 className="text-xl font-bold mb-3">Submit Documents</h3>
            <p className="text-gray-600">Academic transcripts and application form submission</p>
          </div>
          <div className="text-center">
            <div className="bg-blue-600 text-white w-20 h-20 rounded-full flex items-center justify-center text-3xl font-bold mx-auto mb-4">3</div>
            <h3 className="text-xl font-bold mb-3">Assessment</h3>
            <p className="text-gray-600">Review and acceptance within 5-7 business days</p>
          </div>
          <div className="text-center">
            <div className="bg-blue-600 text-white w-20 h-20 rounded-full flex items-center justify-center text-3xl font-bold mx-auto mb-4">4</div>
            <h3 className="text-xl font-bold mb-3">Begin Studies</h3>
            <p className="text-gray-600">Enroll and start your OSSD program with full support</p>
          </div>
        </div>

        {/* Eligibility */}
        <div className="bg-blue-50 border-2 border-blue-200 rounded-3xl p-12">
          <h3 className="text-3xl font-bold text-center mb-10">Eligibility Requirements</h3>
          <div className="grid md:grid-cols-3 gap-8">
            <div>
              <h4 className="font-bold text-xl mb-4 text-blue-600">Academic</h4>
              <ul className="space-y-2">
                <li className="flex items-start">
                  <span className="text-blue-600 mr-2">•</span>
                  <span>Completed O-Levels or equivalent</span>
                </li>
                <li className="flex items-start">
                  <span className="text-blue-600 mr-2">•</span>
                  <span>Minimum 5 passes including Math & English</span>
                </li>
                <li className="flex items-start">
                  <span className="text-blue-600 mr-2">•</span>
                  <span>Science subjects for Science stream</span>
                </li>
              </ul>
            </div>
            <div>
              <h4 className="font-bold text-xl mb-4 text-blue-600">Language</h4>
              <ul className="space-y-2">
                <li className="flex items-start">
                  <span className="text-blue-600 mr-2">•</span>
                  <span>English proficiency required</span>
                </li>
                <li className="flex items-start">
                  <span className="text-blue-600 mr-2">•</span>
                  <span>IELTS 5.5+ or equivalent (if applicable)</span>
                </li>
                <li className="flex items-start">
                  <span className="text-blue-600 mr-2">•</span>
                  <span>Language support available</span>
                </li>
              </ul>
            </div>
            <div>
              <h4 className="font-bold text-xl mb-4 text-blue-600">General</h4>
              <ul className="space-y-2">
                <li className="flex items-start">
                  <span className="text-blue-600 mr-2">•</span>
                  <span>Minimum age: 16 years</span>
                </li>
                <li className="flex items-start">
                  <span className="text-blue-600 mr-2">•</span>
                  <span>Valid identification</span>
                </li>
                <li className="flex items-start">
                  <span className="text-blue-600 mr-2">•</span>
                  <span>Commitment to academic excellence</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
